<template>
  <div>
    <div class="risk-type">
      <div class="risk-type-box">
        <div class="module-title">
          <div class="title-box">
            风险等级动态分析
          </div>
        </div>
        <risk-leve-echarts
          class="risk-leve-chart"
            v-if="infoData.riskDynamicAnalysis.length > 0"
          :echartsData="infoData.riskDynamicAnalysis"
        ></risk-leve-echarts>
      <div v-else class="noData">
        暂无数据
      </div>
      </div>
    </div>
    <div class="school-List">
      <school-list
        :schoolList="infoData.schoolList"
        @clickRow="clickRow"
        ref="schoolList"
        type='risk'
      ></school-list>
    </div>
    <div class="unsafe-type-title">
      <module-title title="风险类型动态分析"></module-title>
    </div>
    <div class="unsafe-type-content">
      <unsafe-type-echarts
        v-if="infoData.riskTypeDynamicAnalysis.length > 0"
        :echartsData="infoData.riskTypeDynamicAnalysis"
      ></unsafe-type-echarts>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="four-color-title">
      <module-title title="风险四色分布图"></module-title>
    </div>
    <div class="four-color-module">
      <four-color-echarts
        v-if="infoData.riskLevelCompare.length > 0"
        :echartsData="infoData.riskLevelCompare"
      ></four-color-echarts>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="hidden-danger-item-zd">
      <div class="item" @click="riskDialog(3, infoData.greatRisk)">
        <div style="font-size:18px">{{ infoData.greatRisk }}</div>
        <div style="font-size:14px">重大风险</div>
      </div>
    </div>
    <div class="hidden-danger-item-jd">
      <div class="item" @click="riskDialog(2, infoData.largenRisK)">
        <div style="font-size:18px">{{ infoData.largenRisK }}</div
        ><div style="font-size:14px">较大风险</div>
      </div>
    </div>
    <div class="hidden-danger-item-yb">
      <div class="item" @click="riskDialog(1, infoData.ordinaryRisk)">
        <div style="font-size:18px">{{ infoData.ordinaryRisk }}</div
        ><div style="font-size:14px">一般风险</div>
      </div>
    </div>
    <div class="hidden-danger-item-jx">
      <div class="item" @click="riskDialog(0, infoData.lesserRisk)">
        <div style="font-size:18px">{{ infoData.lesserRisk }}</div
        ><div style="font-size:14px">低风险</div>
      </div>
    </div>
    <risk-dialog
      :show="riskListShow"
      @close="dialogClose"
      :searchParams="searchData"
    ></risk-dialog>
  </div>
</template>
<script>
import riskLeveEcharts from "./riskLeveEcharts";
import schoolList from "./schoolList";
import moduleTitle from "./moduleTitle";
import fourColorEcharts from "@/components/fourColorEcharts";
import unsafeTypeEcharts from "./unsafeTypeEcharts";
import riskDialog from "./riskDialog";
export default {
  name: "riskStatistics",
  props: {
    infoData: {
      type: Object,
      default: {
        return: {}
      }
    },
    searchParams: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  components: {
    riskLeveEcharts,
    schoolList,
    moduleTitle,
    fourColorEcharts,
    unsafeTypeEcharts,
    riskDialog
  },
  data() {
    return {
      riskListShow: false,
      searchData: this.searchParams
    };
  },
  methods: {
    clickRow(info) {
      this.$emit("clickRow", info);
    },
    dialogClose() {
      this.riskListShow = false;
    },
    riskDialog(val, number) {
      // if (number && number != 0) {
        this.searchData.riskLevel = val;
        this.riskListShow = true;
      // } else {
      //   this.$message({ message: "暂无数据", type: "warning", duration: 1000 });
      // }
    }
  },
  computed: {
    levelNames() {
      return this.$store.state.select.riskLevel.map((item) => {
        return item.levelNameOne;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.risk-type {
  position: absolute;
  top: 80px;
  left: 90px;
  width: 440px;
  height: 300px;
  display: flex;
  justify-content: center;
  .module-title {
    height: 40px;
    width: 220px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title-box {
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
  }
  .risk-type-box {
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/bigDataCollge/chart-view-bg.png") center center no-repeat;
    background-size: 100% 100%;
    .risk-leve-chart {
      height: 250px;
      padding: 0 10px;
    }
    .noData {
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
  }
}
.school-List {
  width: 440px;
  height: 500px;
  position: absolute;
  top: 400px;
  left: 90px;
}
.unsafe-type-title {
  position: absolute;
  top: 600px;
  left: 560px;
}
.unsafe-type-content {
  position: absolute;
  top: 640px;
  left: 560px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.four-color-title {
  position: absolute;
  top: 600px;
  left: 990px;
}
.four-color-module {
  position: absolute;
  top: 640px;
  left: 990px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.hidden-danger-item-zd {
  position: absolute;
  top: 650px;
  left: 1510px;
  width: 100px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    width: 100px;
    height: 78px;
    background: url("~@/assets/img/schoolBigData/new_hidden_danger_red.png") center center no-repeat;
    background-size: 100% 100%;
    color: #ff0000;
    padding-top: 5px;
    cursor: pointer;
  }
}
.hidden-danger-item-jd {
  position: absolute;
  top:618px;
  left: 1590px;
  width: 100px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    height: 78px;
    margin: 0 auto;
    background: url("~@/assets/img/schoolBigData/new_hidden_danger_oragen.png") center center no-repeat;
    background-size: 100% 100%;
    color: #ff6100;
    padding-top: 5px;
    cursor: pointer;
  }
}
.hidden-danger-item-yb {
  position: absolute;
  top: 580px;
  left: 1674px;
  width: 100px;
  z-index: 2;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    height: 78px;
    margin: 0 auto;
    background: url("~@/assets/img/schoolBigData/new_hidden_danger_yellow.png") center center no-repeat;
    background-size: 100% 100%;
    color: #ffff00;
    padding-top: 5px;
    cursor: pointer;
  }
}
.hidden-danger-item-jx {
  width: 100px;
  position: absolute;
  top: 552px;
  left: 1758px;
  z-index: 2;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    height: 78px;
    margin: 0 auto;
    background: url("~@/assets/img/schoolBigData/new_hidden_danger_violet.png") center center no-repeat;
    background-size: 100% 100%;
    color: #7373ff;
    padding-top: 5px;
    cursor: pointer;
  }
}
</style>
